import { css } from "@emotion/css"

export const styles = {
  paper: css`
    /* width: 262px; */
    /* padding: 13px 7px 0 7px; */
  `,

  inputRoot: css`
    svg {
      width: 18px;
      height: 24px;
    }
    .MuiFormControl-marginNormal {
      margin-top: 0;
      margin-bottom: 0;
    }
  `,

  option: css`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 8px;
    &:hover {
      background-color: var(--primary-light);
    }
  `,

  closeIcon: css`
    width: 18px !important;
    height: 18px !important;
    background-color: var(--dark-grey);
    color: var(--white);
    border-radius: 50%;
    cursor: pointer;
  `,
}
